import {FormArray} from "@angular/forms";

export class FormArrayHelpers {
	static moveItemInFormArray(formArray: FormArray, fromIndex: number, toIndex: number): void {
		const dir = toIndex > fromIndex ? 1 : -1;

		const item = formArray.at(fromIndex);
		for (let i = fromIndex; i * dir < toIndex * dir; i = i + dir) {
			const current = formArray.at(i + dir);
			formArray.setControl(i, current, {emitEvent: false});
		}
		formArray.setControl(toIndex, item);
	}

	static transferFormArrayItem(fromArraySource: FormArray, fromArrayTarget: FormArray, fromIndex: number, toIndex: number): void {
		const item = fromArraySource.at(fromIndex);
		fromArraySource.removeAt(fromIndex, {emitEvent: false});
		fromArrayTarget.insert(toIndex, item);
	}
}
